import { render } from "./VesselProtocolCustomsInformation.vue?vue&type=template&id=6cf272a0&scoped=true"
import script from "./VesselProtocolCustomsInformation.vue?vue&type=script&lang=js"
export * from "./VesselProtocolCustomsInformation.vue?vue&type=script&lang=js"

import "./VesselProtocolCustomsInformation.vue?vue&type=style&index=0&id=6cf272a0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf272a0"]])

export default __exports__